import { Component } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
    selector: 'app-selection-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class SelectionButtonComponent extends ButtonComponent {
    constructor() {
        super();
        this.buttonClassesCallback = () => this.buttonClassSet.add('pl-2');
        this.iconClassesCallback = () => this.iconClassSet.add('selection-icon');
        this.svg = this.svg ? this.svg : 'user';
    }
}
